import { EFinancingCompany } from '@if/core/types'
import { Dispatch, SetStateAction, createContext, useContext, useEffect, useMemo, useState } from 'react'
import { Outlet } from 'react-router-dom'
import { useUser } from './UserProvider'

interface TSelectedCompanyContext {
  selectedCompany: EFinancingCompany | null
  setSelectedCompany: Dispatch<SetStateAction<EFinancingCompany | null>>
}

const SelectedCompanyContext = createContext<TSelectedCompanyContext | null>(null)

const SelectedCompanyProvider = () => {
  const user = useUser()
  const userCompany = user?.companyIds ? user.companyIds[0] : null
  const [selectedCompany, setSelectedCompany] = useState<EFinancingCompany | null>(userCompany)

  useEffect(() => {
    if (userCompany !== null) {
      setSelectedCompany(userCompany)
    }
  }, [userCompany])

  const value = useMemo<TSelectedCompanyContext>(
    () => ({
      selectedCompany,
      setSelectedCompany,
    }),
    [selectedCompany],
  )

  return (
    <SelectedCompanyContext.Provider value={value}>
      <Outlet />
    </SelectedCompanyContext.Provider>
  )
}

export const useSelectedCompany = () => {
  const ctx = useContext(SelectedCompanyContext)
  return ctx!.selectedCompany!
}

export const useSetSelectedCompany = () => {
  const ctx = useContext(SelectedCompanyContext)
  return ctx!.setSelectedCompany
}

export default SelectedCompanyProvider
